import * as React from 'react';
import * as _ from 'lodash';
import GoogleMapReact from 'google-map-react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchOneTermWP } from '../actions/categories';
import { fetchStoreWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import ListStore from './component/ListStore';
import StoreRelated from './component/StoreRelated';
import { isEmpty, mapOptions } from '../helpers/index';

class CateStores extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true
		};
	}

	componentDidMount() {
		if (this.props.match.params.cate_id) {
			this.props.fetchStoreWP({
				post_type: 'store',
				number: 100
			});
			this.props.fetchOneTermWP({
				term_id: this.props.match.params.cate_id,
				term_name: 'store_categories'
			});
		} else {
			this.props.history.push('/');
		}
		document.title = this.props.t('stores');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.termOneWP.loading == false && nextProps.storesWP.loading == false) {
			this.setState({
				loading: false
			});
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.termOneWP.loading || nextProps.storesWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	onChildClick = (key, childProps) => {
		var category_slug = '';

		if (this.props.match.params.cate_slug) {
			category_slug = this.props.match.params.cate_slug;
		}
		this.props.history.push(`/store-detail/${category_slug}/${key}/${childProps.slug}`);
	};

	render() {

		const { storesWP, termOneWP, t } = this.props;

		var category_slug = '';

		if (this.props.match.params.cate_slug) {
			category_slug = this.props.match.params.cate_slug;
		}

		var data_categories = _.filter(storesWP.data, function (post) {
			return _.some(post.terms, { 'slug': category_slug, 'taxonomy': 'store_categories' });
		});

		var list_store = data_categories.map(item => {
			var lat = '';
			var long = '';
			if (item.custom_fields.length > 0) {
				lat = item.custom_fields[2]['value'];
				long = item.custom_fields[3]['value'];
			}
			return (
				<ListStore key={item.post_id} slug={item.post_name} lat={lat} lng={long}
				           img={require('../img/ico-markerStar.png')}/>
			);
		});

		let allRelatedStores = _.filter(storesWP.data, function (post) {
			return _.some(post.terms, { 'slug': category_slug, 'taxonomy': 'store_categories' });
		});

		let filteredStores = [];
		allRelatedStores.map((store) => {
			let storeHtml = <StoreRelated cate_slug={category_slug} key={store.post_id} store={store}/>;
			filteredStores.push(storeHtml);
		});

		var lat = 16.2414252;
		var long = 109.6139389;

		if (isEmpty(termOneWP.data)) {
			if (termOneWP.data.custom_fields.length > 0) {
				lat = parseFloat(termOneWP.data.custom_fields[1]['value']);
				long = parseFloat(termOneWP.data.custom_fields[2]['value']);
			}
		}

		return (
			<div>
				<div className="mapContainer mapContainerDetail">
					<div className="section mapWrap">
						<div id="map">
							<GoogleMapReact
								bootstrapURLKeys={{ key: process.env.REACT_APP_KEY_GOOGLE_MAP }}
								center={[lat, long]}
								zoom={12}
								options={mapOptions}
								onChildClick={this.onChildClick}
							>
								{list_store}
							</GoogleMapReact>
						</div>
					</div>
					<div className="filters panel">
						<div className="filter set opened" id="opened">
							<h2>
								<img src={require('../img/icon-opened.png')} width={15}/>
								{termOneWP.data.name}
							</h2>
						</div>
						<div className="back panel">
							<Link to="/stores" title="Go Back" style={{ textTransform: 'uppercase' }}>
								<img src={require('../img/icon-back.png')} width={55}/> {t('back_page')}
							</Link>
						</div>
					</div>
				</div>
				<div className="clearfix"></div>
				<div className="related wall">
					<h3>Cộng CàPhê tại {termOneWP.data.name}</h3>
					<div className="listStore">
						{filteredStores}
					</div>
				</div>
				{this.state.loading ?
					<div className="loadingPage active"><img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>

		);
	}
}

export default connect(mapStateToProps([
	'storesWP', 'termOneWP'
]), mapDispatchToProps({
	fetchStoreWP, fetchOneTermWP
}))(translate('translations')(CateStores));



// WEBPACK FOOTER //
// ./src/containers/CateStores.tsx